import { Faction } from '../../utils/faction';
import AttackOrder from '../order/attackOrder';
import AttackMoveToOrder from '../order/attackMoveToOrder';
import Order from '../order/order';
import Music, { MusicParams } from './music';

export interface DoubleMusicParams extends MusicParams {
  music1Params: MusicParams;
  music2Params: MusicParams;
}

/* Is supposed to be used with 2 fairly comparable musics in order to switch from one to another */
export default class DoubleMusic extends Music implements DoubleMusicParams {
  music1Params!: MusicParams;
  music2Params!: MusicParams;

  music1: Music;
  music2: Music;
  activeMusic: Music;
  mutedMusic: Music;
  musicSwitchInterval!: number;

  constructor(params: DoubleMusicParams) {
    super(params);
    this.applyParams(params);

    this.music1 = new Music(this.music1Params as MusicParams);
    this.activeMusic = this.music1;
    this.activeMusic.volume = this.volume;
    this.activeMusic.setVolume(this.activeMusic.volume);

    this.music2 = new Music(this.music2Params as MusicParams);
    this.mutedMusic = this.music2;
    this.mutedMusic.volume = 0;
    this.mutedMusic.setVolume(this.mutedMusic.volume);
  }

  getAudio(): HTMLAudioElement {
    return this.music1.audio;
  }

  setAudio(): void {
    return;
  }

  play(): DoubleMusic {
    this.music1.play();
    this.music2.play();
    this.watchForMusicSwitch();
    return this;
  }

  pause(): DoubleMusic {
    this.music1?.pause();
    this.music2?.pause();
    this.stopSwitching();
    return this;
  }

  setVolume(volume: number): DoubleMusic {
    this.music1.setVolume(volume);
    this.music2.setVolume(volume);
    return this;
  }

  fadeToVolume(volumeToReach = 0, duration = 1000): void {
    this.music1.fadeToVolume(volumeToReach, duration);
    this.music2.fadeToVolume(volumeToReach, duration);
  }

  /* fade the musics one into another for a smooth transition */
  switch(index: number, fadeTime?: number): void {
    if (index === 1 && this.activeMusic === this.music1)
      return;
    if (index === 2 && this.activeMusic === this.music2)
      return;

    switch (index) {
      case 1: // #1 becomes active
        this.activeMusic = this.music1;
        this.activeMusic.fadeToVolume(this.volume, fadeTime);
        this.mutedMusic = this.music2;
        this.mutedMusic.fadeToVolume(0, fadeTime);
        break;

      case 2: // #2 becomes active
        this.activeMusic = this.music2;
        this.activeMusic.fadeToVolume(this.volume, fadeTime);
        this.mutedMusic = this.music1;
        this.mutedMusic.fadeToVolume(0, fadeTime);
        break;

      default: // just toggle the active and muted
        {
          this.mutedMusic.fadeToVolume(this.activeMusic.volume, fadeTime);
          this.activeMusic.fadeToVolume(0, fadeTime);
          const temp = this.activeMusic;
          this.mutedMusic = this.activeMusic;
          this.activeMusic = temp;
        }
        break;
    }
  }

  watchForMusicSwitch(): void {
    this.musicSwitchInterval = window.setInterval(() => {
      const enemiesWithHostileIntentions = Object.values(this.scene.elements)
        .filter(el => {
          return (
            el.faction === Faction.ENEMY
            && el.behaviour
            && el.behaviour.orders.some((order: Order) => {
              return (
                (order instanceof AttackOrder || order instanceof AttackMoveToOrder)
                && order.target
                && order.target.faction === Faction.PLAYER
              );
            })
          );
        })
        ;
      const transitionTime = 1000;
      if (enemiesWithHostileIntentions.length > 0)
        this.switch(2, transitionTime);
      else
        this.switch(1, transitionTime);

    }, 1000);
  }

  stopSwitching(): void {
    window.clearInterval(this.musicSwitchInterval);
  }
}
